import Repo from './Base';
import authService from '../components/api-authorization/AuthorizeService';

const resource = '/me';

export default {

  async getMe() {
    const token = await authService.getAccessToken();
    try {
      let result = await Repo.get(
        `${resource}`,
        { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } });
      if (result.status === 200) {
        return result.data;
      } else {
        const error = new Error(`HTTP ${result.status}`);
        error.status = result.status;
        error.response = result;
        throw error;
      }
    } catch (err) {
      // Extract status from axios error
      const status = err.response?.status || err.status;
      const error = new Error(`HTTP ${status || 'Unknown'}: ${err.message}`);
      error.status = status;
      error.response = err.response;
      throw error;
    }
  },

  async getClasses() {
    const token = await authService.getAccessToken();
    try {
      let result = await Repo.get(
        `${resource}/classes`,
        { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } });
      if (result.status === 200) {
        return result.data;
      } else {
        const error = new Error(`HTTP ${result.status}`);
        error.status = result.status;
        error.response = result;
        throw error;
      }
    } catch (err) {
      const status = err.response?.status || err.status;
      const error = new Error(`HTTP ${status || 'Unknown'}: ${err.message}`);
      error.status = status;
      error.response = err.response;
      throw error;
    }
  },

  async checkAgreement(classId) {
    const token = await authService.getAccessToken();
    try {
      let result = await Repo.post(
        `/Classes/${classId}/acceptAgreement`, "",
        { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } });
      if (result.status === 200) {
        return true;
      } else {
        const error = new Error(`HTTP ${result.status}`);
        error.status = result.status;
        error.response = result;
        throw error;
      }
    } catch (err) {
      const status = err.response?.status || err.status;
      if (status === 401 || status === 403) {
        const error = new Error(`Authentication failed: HTTP ${status}`);
        error.status = status;
        error.response = err.response;
        throw error;
      }
      return false;
    }
  },

  async getVideoLogs(classIdId) {
    const token = await authService.getAccessToken();
    try {
      let result = await Repo.get(
        `${resource}/classes/${classIdId}/videoLogs`,
        { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } });
      if (result.status === 200) {
        return result.data;
      } else {
        const error = new Error(`HTTP ${result.status}`);
        error.status = result.status;
        error.response = result;
        throw error;
      }
    } catch (err) {
      const status = err.response?.status || err.status;
      const error = new Error(`HTTP ${status || 'Unknown'}: ${err.message}`);
      error.status = status;
      error.response = err.response;
      throw error;
    }
  },

};


